import _ from 'underscore';
import xtend from 'xtend';

export default {
    // return an object whos values are not the defaults
    Difference: function (defaults, data) {
        return _(data).reduce(function (acc, val, key) {
            if (val !== defaults[key]) acc[key] = val;
            return acc;
        }, {});
    },

    // merge existing state with the given object
    Update: function (state, data) {
        state.set(xtend(state(), data));
    }
};
